import {ListItem} from "~/pages/level3/extracted-result-page/extracted-result-content/tools/types";

export const EXTRACTED_RESULT = 'EXTRACTED_RESULT'
export const getExtractedResult = (): ListItem[]=>{
    const extractedResultStr = localStorage.getItem(EXTRACTED_RESULT)
    if(extractedResultStr){
        const extractedResult = JSON.parse(extractedResultStr)
        console.log('extracted result', extractedResult)
        return extractedResult
    }
    return []
}

export const updateExtractedResult = (params: {
    targetKey?: keyof ListItem
    targetValue?: any
    updateKey: keyof ListItem
    updateValue: any
    targetIndex?: number
}) => {
    const {targetKey, targetValue, updateValue, updateKey, targetIndex} = params
    const extractedResult = getExtractedResult()
    // 确保targetKey和targetValue都存在，或者提供了targetIndex
    if ((targetKey === undefined || targetValue === undefined) && targetIndex === undefined) {
        console.error('必须提供targetKey和targetValue，或者提供targetIndex')
        return
    }

    // 找到目标索引
    const index = targetIndex !== undefined ? targetIndex :
        extractedResult.findIndex(item => targetKey !== undefined && item[targetKey] === targetValue)

    console.log('extracted info', extractedResult, index)

    // 确保索引有效
    if(index >= 0 && index < extractedResult.length){
        if (updateKey) {
            // 检查当前值的类型
            (extractedResult[index] as any)[updateKey] = updateValue
            localStorage.setItem(EXTRACTED_RESULT, JSON.stringify(extractedResult))
        }
    } else {
        console.error('未找到要更新的项目，索引:', index)
    }
}
export const isAIExtractedItem = (firstId?: string)=>{
    const res = getExtractedResult()
    if(!firstId) return false
    return res.find(item => item.firstId === firstId)
}